import React, { useRef } from "react";
import emailjs from "@emailjs/browser";
import "./Email.css";
import { useFormik } from "formik";
import * as Yup from "yup";

export const Email = () => {
  const form = useRef();

  const formik = useFormik({
    initialValues: {
      user_name: "",
      user_email: "",
      message: "",
    },
    validationSchema: Yup.object({
      user_name: Yup.string()
        .required("Required")
        .min(3, "Must be more than 3 character"),
      user_email: Yup.string()
        .required("Required")
        .email("Invaild email address"),
      message: Yup.string()
        .required("Required")
        .min(90, "Must be 90 Character long!"),
    }),
    onSubmit: (values, onSubmitProps) => {
      emailjs
        .sendForm(
          "service_f2c2iml",
          "template_69xetta",
          form.current,
          "nB9QIezKA0X5HdUYv"
        )
        .then(
          (result) => {
            console.log(result.text);
          },
          (error) => {
            console.log(error.text);
          }
        );
      onSubmitProps.resetForm();
      onSubmitProps.setStatus({ success: "Email has been successfully sent" });
    },
  });
  return (
    <form ref={form} onSubmit={formik.handleSubmit} className='email-container'>
      <label>Name</label>
      <input
        type='text'
        name='user_name'
        placeholder='Example: Andrew Roy'
        onChange={formik.handleChange}
        value={formik.values.user_name}
        onBlur={formik.handleBlur}
      />
      {formik.touched.user_name && formik.errors.user_name ? (
        <p className='warning'>{formik.errors.user_name}</p>
      ) : null}
      <label>Email</label>
      <input
        type='email'
        name='user_email'
        placeholder='Example: eda.twinkle@gmail.com'
        onChange={formik.handleChange}
        value={formik.values.user_email}
        onBlur={formik.handleBlur}
      />
      {formik.touched.user_email && formik.errors.user_email ? (
        <p className='warning'>{formik.errors.user_email}</p>
      ) : null}
      <label>Message</label>
      <textarea
        name='message'
        onChange={formik.handleChange}
        value={formik.values.message}
      />
      {formik.touched.message && formik.errors.message ? (
        <p className='warning'>{formik.errors.message}</p>
      ) : null}
      <input type='submit' value='Send' />
      {formik.status ? <p className='success'>{formik.status.success}</p> : ""}
    </form>
  );
};
